// extracted by mini-css-extract-plugin
module.exports = {"carousel":"category-carousel_carousel__BuF_f","carousel__card":"category-carousel_carousel__card__fGEOd","loading":"category-carousel_loading__Evt9Y"};